/**
 * Pure clinic-settings rules (ZOY-252 / ZOY-287).
 */

import type { ClinicView } from '@/core/clinic/api';
import type { ClinicSettingsPatch } from '@/core/clinic/setupApi';

/** ZOY-252 bounds (verified): minutes each way. */
export const TRAVEL_MIN = 0;
export const TRAVEL_MAX = 480;

/**
 * Only the members that actually changed are sent; an unchanged member is
 * OMITTED (ZOY-287: `defaultBufferMinutes` must never be null). Returns an
 * empty patch when nothing changed. The schedule-SMS switch (tasks#138) is
 * sent only when the read carried it: a backend without the field refuses it.
 */
export function settingsPatch(
  current: ClinicView['settings'],
  next: Required<ClinicSettingsPatch>,
): ClinicSettingsPatch {
  const out: ClinicSettingsPatch = {};
  if (next.calendarSystem !== current.calendarSystem) out.calendarSystem = next.calendarSystem;
  if (next.currencyCode !== current.currencyCode) out.currencyCode = next.currencyCode;
  if (next.timezone !== current.timezone) out.timezone = next.timezone;
  if (next.defaultBufferMinutes !== current.defaultBufferMinutes)
    out.defaultBufferMinutes = next.defaultBufferMinutes;
  if (next.defaultTravelAllowanceMinutes !== current.defaultTravelAllowanceMinutes)
    out.defaultTravelAllowanceMinutes = next.defaultTravelAllowanceMinutes;
  if (
    current.practitionerScheduleSms !== undefined &&
    next.practitionerScheduleSms !== current.practitionerScheduleSms
  )
    out.practitionerScheduleSms = next.practitionerScheduleSms;
  return out;
}
